export const EXPRESS_DESIGNER_SEGMENT = {
  Cart: 'cart',
} as const;
